import Image from 'next/image'
import { TestimonialContainer, TestimonialImageContainer } from './styled'
import { Box, Typography } from '@mui/material'

const Testimonial = ({
  projectTestimonial,
  alternativeTestimonial,
}: {
  projectTestimonial?: ITestimonialsResult
  alternativeTestimonial?: IAlternativeTestimonial
}) => {
  const testimonialData = () => {
    if (alternativeTestimonial) {
      return {
        name: alternativeTestimonial.name,
        photo: alternativeTestimonial.photo.fullSize,
        altText: alternativeTestimonial.photoAltText,
        position: alternativeTestimonial.position,
      }
    }
    if (projectTestimonial) {
      return {
        name: projectTestimonial.clientName,
        photo: projectTestimonial.clientPhoto.fullSize,
        altText: projectTestimonial.clientPhotoAltText,
        position: projectTestimonial.clientPosition,
      }
    }
    return {
      name: '',
      photo: '',
      altText: '',
      position: '',
    }
  }

  return (
    <TestimonialContainer>
      <TestimonialImageContainer>
        <Image
          src={testimonialData().photo}
          alt={testimonialData().altText || ''}
          layout="fill"
          objectFit="cover"
        />
      </TestimonialImageContainer>
      <Box component="div">
        <Typography variant="subtitle2">{testimonialData().name}</Typography>
        <Typography variant="body2">{testimonialData().position}</Typography>
      </Box>
    </TestimonialContainer>
  )
}

export default Testimonial
